import React, { FunctionComponent } from 'react';
import ReusableTabs from '../common/ReusableTabs';
import * as styles from '../productPage/tableComponents/ProductPage_style';
import Portals from './Portals';
import BreadCrumbs from '../common/BreadCrumbs';
import { useSalesAndResourcesDistributorPortalsContent } from '../../graphql/pimcore/modules/siteContent/hooks/useSalesAndResourcesDistributorPortalsContent';

interface DistributorPortalHomeProps {}

const DistributorPortalHome: FunctionComponent<DistributorPortalHomeProps> = ({}) => {
    const { loading, error, contentTree } = useSalesAndResourcesDistributorPortalsContent();

    return (
        <ReusableTabs
            bannerImage={contentTree.pageTitleBackgroundImage.imageUrl}
            bannerTitle={contentTree.pageTitle.content}
            bannerDescription={contentTree.pageSubtitle.content}
            tabLabels={[]}
            tabKeys={['']}
            tabContents={[<Portals key="portals" contentTree={contentTree} />]}
            bannerFontStyle={styles.bannerFont}
            subBannerFontStyle={styles.bannerFont2}
            pageName={'distributorPortal'}
            showTabs={false}
            breadcrumbs={
                <BreadCrumbs navigationPath="/Home/SalesAndResources/DistributorPortals" />
            }
        />
    );
};

export default DistributorPortalHome;
